/**
 * Campus Framework API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@bitapp.it
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { DebugInfo } from './debugInfo';


export interface SupportRequest { 
    text: string;
    platform: SupportRequestPlatformEnum;
    debugInfo: DebugInfo;
    badgeNumber: string;
    name: string;
    type: SupportRequestTypeEnum;
}
export enum SupportRequestPlatformEnum {
    IOs = 'iOS',
    Android = 'Android'
};
export enum SupportRequestTypeEnum {
    Error = 'error',
    Support = 'support'
};



